import { useTranslation } from 'react-i18next'
import type { ResourceItem } from '../types'
import { RESOURCE_TYPE } from '../types'

interface ResourceCardProps {
  readonly item: ResourceItem
  readonly onClick: () => void
}

const TYPE_COLORS: Readonly<Record<string, string>> = {
  [RESOURCE_TYPE.CHECKPOINT]: '#8b5cf6',
  [RESOURCE_TYPE.LORA]: '#3b82f6',
  [RESOURCE_TYPE.VAE]: '#10b981',
  [RESOURCE_TYPE.CONTROLNET]: '#f59e0b',
  [RESOURCE_TYPE.UPSCALER]: '#ec4899',
  [RESOURCE_TYPE.EMBEDDING]: '#6366f1',
}

const SOURCE_COLORS: Readonly<Record<string, string>> = {
  local: '#6b7280',
  civitai: '#2563eb',
  huggingface: '#fbbf24',
}

function truncatePath(filePath: string, maxLength: number = 40): string {
  if (filePath.length <= maxLength) return filePath
  return `...${filePath.slice(-(maxLength - 3))}`
}

export function ResourceCard({ item, onClick }: ResourceCardProps) {
  const { t } = useTranslation()

  const typeColor = TYPE_COLORS[item.resource_type] ?? '#6b7280'
  const sourceColor = SOURCE_COLORS[item.source] ?? '#6b7280'

  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex flex-col gap-2 overflow-hidden rounded-xl border border-tg-hint/10 p-3 text-left transition-all duration-200 active:scale-[0.97] bg-tg-secondary hover:border-tg-hint/20 hover:shadow-lg"
    >
      {/* Name */}
      <span
        className="truncate text-sm font-medium text-tg-text"
      >
        {item.name}
      </span>

      {/* Badges */}
      <div className="flex gap-1.5">
        <span
          className="rounded-full px-2 py-0.5 text-[10px] font-medium"
          style={{ backgroundColor: `${typeColor}20`, color: typeColor }}
        >
          {t(`resources.filter.${item.resource_type}`)}
        </span>
        <span
          className="rounded-full px-2 py-0.5 text-[10px] font-medium"
          style={{ backgroundColor: `${sourceColor}20`, color: sourceColor }}
        >
          {item.source}
        </span>
      </div>

      {/* File path */}
      <span
        className="truncate text-[10px] text-tg-hint"
      >
        {truncatePath(item.file_path)}
      </span>
    </button>
  )
}
